// Components
import { PopUpBackground } from "./styles";

const Popup = ({ children, isShowed, setIsShowed, backgroundId = "popUpBackground" }) => {
  const handleHidePopupAcrossBackground = (e) => {
    if (e.target.id === backgroundId) {
      setIsShowed(false);
    }
  };

  return (
    <PopUpBackground onClick={handleHidePopupAcrossBackground} id={backgroundId} isShowed={isShowed}>
      {children}
    </PopUpBackground>
  );
};

export default Popup;
